import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Icon, MaterialHint, Button } from 'shared/components';
import { ArchivedAppointmentsSidebar } from 'modules/queues/Archive/containers';
import { AppointmentsSidebar as PatientAppointmentsSidebar } from 'modules/queues/Schedule/containers';

import theme from './AppointmentsSidebar.scss';

const propTypes = {
  appointmentsTotal: PropTypes.number.isRequired,
  archiveOpened: PropTypes.bool.isRequired,
  openArchive: PropTypes.func.isRequired,
  closeArchive: PropTypes.func.isRequired,
  showAppointmentFormBtn: PropTypes.bool.isRequired,
  openAppointmentForm: PropTypes.func.isRequired,
  hideArchive: PropTypes.bool,
  rtl: PropTypes.bool.isRequired,
  intl: PropTypes.shape().isRequired,
};

const defaultProps = {
  hideArchive: true,
};

const AppointmentsSidebar = ({
  appointmentsTotal,
  archiveOpened,
  openArchive,
  closeArchive,
  showAppointmentFormBtn,
  hideArchive,
  openAppointmentForm,
  intl,
  rtl,
}) => (
  <div className={ theme.root }>
    <div className={ theme.header }>

      <Choose>
        <When condition={ archiveOpened }>
          <button
            data-testid="back-from-archive-button"
            aria-label={ intl.formatMessage({
              id: 'General.Back',
              defaultMessage: '** Back',
            }) }
            className={ theme.backFromArchive }
            onClick={ closeArchive }
          >
            <Icon name={ rtl ? 'arrow-right' : 'arrow-left' } />
          </button>


          <h1 role="alert" aria-live="polite" tabIndex={ 0 }>
            { intl.formatMessage({ id: 'Appointments.AppointmentsList.ArchiveListHeader.Label', defaultMessage: '** Archived' }) }
          </h1>
        </When>
        <Otherwise>
          <h1 role="alert" aria-live="polite" tabIndex={ 0 }>
            { intl.formatMessage({ id: 'Appointments.AppointmentsList.Header', defaultMessage: '** Consultations' }) }
          </h1>
          <If condition={ hideArchive === false }>
            <MaterialHint
              placement="bottom"
              title={ intl.formatMessage({
                id: 'Appointments.AppointmentsList.ArchiveAccess.Button.Tooltip',
                defaultMessage: '** Archived appointments',
              }) }
            >
              <button
                className={ theme.iconContainer }
                onClick={ openArchive }
                aria-label={ intl.formatMessage({
                  id: 'Appointments.AppointmentsList.ArchiveAccess.Button.Tooltip',
                  defaultMessage: '** Archived appointments',
                }) }
              >
                <Icon className={ theme.archiveIcon } name="archive-drawer" />
              </button>
            </MaterialHint>
          </If>
        </Otherwise>
      </Choose>

      <span className={ theme.appointmentsFound }>
        <FormattedMessage
          id="Appointments.AppointmentsList.Search.Filter.NumberOfResults"
          values={{ n: appointmentsTotal }}
        />
      </span>
    </div>

    <Choose>
      <When condition={ archiveOpened }>
        <ArchivedAppointmentsSidebar />
      </When>
      <Otherwise>
        <PatientAppointmentsSidebar />
      </Otherwise>
    </Choose>

    <If condition={ showAppointmentFormBtn && !archiveOpened }>
      <MaterialHint
        placement="top"
        title={ intl.formatMessage({
          id: 'Appointments.Create.FAB.Tooltip',
          defaultMessage: '** Create a new appointment',
        }) }
      >
        <div className={ theme.createAppointmentButton }>
          <Button
            testId="create-appointment-btn"
            color="primary"
            ariaLabel={ intl.formatMessage({
              id: 'Appointments.Create.FAB.Tooltip',
              defaultMessage: '** Create a new appointment',
            }) }
            background="greenMedium"
            buttonType="circle"
            onClick={ openAppointmentForm }
            className={ theme.createAppointmentButtonIcon }
          >
            <Icon name="plus" />
          </Button>
        </div>
      </MaterialHint>
    </If>
  </div>
);

AppointmentsSidebar.propTypes = propTypes;
AppointmentsSidebar.defaultProps = defaultProps;

export default AppointmentsSidebar;
